/* Video playback, shared by Options A, B and C. One video plays at a time, off-screen videos pause, and nothing plays hidden.
   The poster shows only while a player really loads: it is revealed the moment the player reports playing. */
(function () {
  const root = document.documentElement;
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const save = navigator.connection && navigator.connection.saveData;
  const PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
  const PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2l10 6-10 6z"/></svg>';

  /* ---------- the sticky header and caption strips count toward the height a feature may use ---------- */
  function measure() {
    const head = document.querySelector('.section-aad-header');
    const sticky = head && getComputedStyle(head).position === 'sticky' ? head.offsetHeight : 0;
    root.style.setProperty('--aad-optc-sticky', sticky + 'px');
    const ann = document.querySelector('.aad-announce');
    root.style.setProperty('--aad-optc-ann', (ann ? ann.offsetHeight : 0) + 'px');
    document.querySelectorAll('[data-optc-feature]').forEach(f => {
      const strip = f.querySelector('.aad-optc-strip');
      f.style.setProperty('--aad-optc-strip-h', (strip ? strip.offsetHeight : 0) + 'px');
    });
  }
  measure();
  addEventListener('resize', measure);
  addEventListener('load', measure);

  /* ---------- whichever visible video is most on screen plays; every other one pauses ---------- */
  const players = [];
  function arbitrate() {
    let best = null;
    players.forEach(p => { if (!p.held && p.seen >= 0.35 && (!best || p.seen > best.seen)) best = p; });
    players.forEach(p => { if (p !== best) p.pause(); });
    if (best) best.play();
  }

  function mark(p, on) {
    p.btn.innerHTML = on ? PAUSE : PLAY;
    p.btn.setAttribute('aria-label', on ? 'Pause background video' : 'Play background video');
  }

  function register(p, el) {
    p.seen = 0;
    p.held = false;
    p.btn = el.closest('.aad-optc-frame').querySelector('[data-optc-toggle]');
    p.btn.hidden = false;
    p.btn.addEventListener('click', () => {
      p.held = !p.held;
      mark(p, !p.held);
      arbitrate();
    });
    players.push(p);
    new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting && p.prepare) p.prepare();
    }), { rootMargin: '100% 0px 100% 0px' }).observe(el.closest('.aad-optc-frame'));
    new IntersectionObserver(es => es.forEach(e => {
      p.seen = e.isIntersecting ? e.intersectionRatio : 0;
      arbitrate();
    }), { threshold: [0, 0.2, 0.35, 0.5, 0.75, 1] }).observe(el.closest('.aad-optc-frame'));
  }

  const still = el => { const m = el.closest('.aad-optc-media'); if (m) m.classList.add('is-still'); };

  /* ---------- store-hosted video ---------- */
  function initStore(video) {
    if (reduce || save) return still(video);
    video.addEventListener('error', () => {
      /* A smaller file that fails falls back to the stream before the artwork. */
      if (video.dataset.hls && !video.dataset.triedHls) {
        video.dataset.triedHls = '1';
        video.src = video.dataset.hls + (video.dataset.start ? '#t=' + video.dataset.start : '');
        video.play().catch(() => {});
      } else still(video);
    });
    video.addEventListener('playing', () => {
      video.classList.add('is-on');
      if (!video.dataset.firstFrameMs) video.dataset.firstFrameMs = Math.round(performance.now());
    });
    const p = {
      prepare() { window.aadOptcLoad(video); },
      play() {
        window.aadOptcLoad(video);
        const r = video.play();
        if (r && r.catch) r.catch(() => mark(p, false));
        mark(p, true);
      },
      pause() { if (!video.paused) video.pause(); }
    };
    register(p, video);
  }

  /* ---------- YouTube: cued in advance, never playing behind the poster ---------- */
  function initYouTube(box) {
    if (reduce || save) return still(box);
    const id = box.dataset.optcYt;
    let frame = null, state = null, wanted = false, tries = 0, timer = 0, talk = 0, asked = 0;
    const send = fn => { if (frame && frame.contentWindow) frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: fn, args: [] }), '*'); };
    function push() {
      clearTimeout(timer);
      if (!wanted || state === 1) return;
      send('playVideo');
      if (++tries > 30) { wanted = false; mark(p, false); box.dataset.startFailed = '1'; return; }
      timer = setTimeout(push, 400);
    }
    const p = {
      prepare() {
        if (frame) return;
        frame = document.createElement('iframe');
        frame.className = 'aad-optc-ytframe';
        frame.title = '';
        frame.tabIndex = -1;
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('allow', 'autoplay; encrypted-media');
        frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=0&mute=1&loop=1&playlist=${encodeURIComponent(id)}&controls=0&disablekb=1&fs=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&enablejsapi=1&origin=${encodeURIComponent(location.origin)}`;
        frame.addEventListener('load', () => {
          const hello = () => { if (frame.contentWindow) frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*'); };
          hello();
          clearInterval(talk);
          talk = setInterval(hello, 500);
          if (wanted) push();
        });
        box.appendChild(frame);
      },
      play() {
        if (wanted) return;
        wanted = true;
        tries = 0;
        if (!asked) asked = performance.now();
        p.prepare();
        mark(p, true);
        push();
      },
      pause() {
        wanted = false;
        clearTimeout(timer);
        if (frame && state !== 2) send('pauseVideo');
      }
    };
    addEventListener('message', e => {
      if (!frame || e.source !== frame.contentWindow || typeof e.data !== 'string') return;
      let d = null;
      try { d = JSON.parse(e.data); } catch (err) { return; }
      clearInterval(talk);
      let next = null;
      if (d.event === 'onStateChange') next = d.info;
      else if (d.info && typeof d.info === 'object' && 'playerState' in d.info) next = d.info.playerState;
      if (next === null) return;
      state = next;
      if (state === 1) {
        frame.classList.add('is-on');
        if (!box.dataset.startMs) box.dataset.startMs = Math.round(performance.now() - asked);
        if (!wanted) send('pauseVideo');
      }
    });
    register(p, box);
  }

  function boot(scope) {
    scope.querySelectorAll('[data-optc-store]').forEach(initStore);
    scope.querySelectorAll('[data-optc-yt]').forEach(initYouTube);
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
